// extracted by mini-css-extract-plugin
export default {"overlay":"WindowAlert_overlay__UmyIV","alert":"WindowAlert_alert__fd9ST","body":"WindowAlert_body__crnZU"};